import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '../../../../components/common/Typography';
import TextField from '../../../../components/common/TextField';
import { formatNumber } from '../../../../common/Util';

// 실비
const CompensationSection = ({ dataList, handleChange }) => {
  const { t } = useTranslation('deductions/medicalExpenses');

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      <div className="displayFlex" style={{ gap: '10px' }}>
        <Typography variant="body1Bold">{t('detail.title2')}</Typography>
        <div className="titleLine"></div>
      </div>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        <TextField
          label={t('detail.inputLabel6')}
          size="small"
          value={formatNumber(dataList[0]?.htmSilB)}
          name="htmSilB"
          onChange={() => {}}
          disabled={true}
        />
        <TextField
          label={t('detail.inputLabel7')}
          size="small"
          value={formatNumber(dataList[0]?.htmSilB2)}
          name="htmSilB2"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default CompensationSection;
